import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {
  readonly UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

  transform(value: number): string {
    let l = 0;
    let n = value;

    while (n >= 1024){
      n = n / 1024;
      l++;
    }

    return (n.toFixed(n >= 10 || l < 1 ? 0 : 1) + ' ' + this.UNITS[l]);
  }

}
